module.exports = __webpack_public_path__ + "static/img/sunlight.dbc3a3e0.png";